import React, { useEffect, useState } from "react";
import { useIsFocused } from '@react-navigation/native'
import isEqual from 'react-fast-compare'
import HelperPlatform from 'utils/helper-platform'
import { useDispatch } from 'react-redux'
import { setData } from 'services/redux/data/actions'
import { dataConstants } from 'services/redux/data/constants'

const IsFocusedToRedux = () => {
	const dispatch = useDispatch()
	const isFocused = useIsFocused();
	const [ isWindowVisible, setIsWindowVisible ] = useState( true );
	
	const onVisibilityChanges = ( e ) => {
		setIsWindowVisible( ( e ? e.target.visibilityState : global.document.visibilityState ) === 'visible' );
	}
	
	useEffect(() => {
		if( HelperPlatform.isWeb() ){
			dispatch( setData( dataConstants.APP_IS_FOCUSED, isWindowVisible ) );
		}else{
			dispatch( setData( dataConstants.APP_IS_FOCUSED, isFocused ) );
		}
	}, [ isFocused, isWindowVisible ] );
	
	useEffect( () => {
		if( HelperPlatform.isWeb() && global.document !== undefined ){
			onVisibilityChanges();
			global.document.addEventListener( 'visibilitychange', onVisibilityChanges);
		}
	}, [] );
	
	return null;
}

export default React.memo( IsFocusedToRedux, isEqual );